import { useEffect, useState } from 'react';

/** Whether the window matches a media query, kept current as it changes. False where there is no window to ask. */
export function useMediaQuery(query: string): boolean {
  const ask = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(ask);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const update = () => setMatches(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [query]);
  return matches;
}

/** Tailwind's `lg` (64rem): the image list and the right panel stand beside the image instead of over it. */
export const LARGE_QUERY = '(min-width: 64rem)';

/** Whether the window is `lg` now, outside React (a key handler). False where there is no window to ask. */
export function isLargeNow(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(LARGE_QUERY).matches;
}

export function useIsLarge(): boolean {
  return useMediaQuery(LARGE_QUERY);
}
